import React from 'react';
export function PersonalizedVoicemails() {
  return <section className="bg-[#FFB5C5] py-20 px-4 md:px-8" data-id="element-132">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-133">
        <h2 className="text-5xl md:text-6xl font-bold mb-8 text-[#1a1a1a]" data-id="element-134">
          Personalized Greetings
        </h2>

        <div className="bg-white/20 backdrop-blur-sm p-8 rounded-3xl border border-white/30 shadow-lg mb-12" data-id="element-135">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-136">
            <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center text-white flex-shrink-0 shadow-lg" data-id="element-137">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-138">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" data-id="element-139" />
              </svg>
            </div>
            <div className="flex-grow text-left" data-id="element-140">
              <div className="h-12 flex items-center gap-1" data-id="element-141">
                {[...Array(20)].map((_, i) => <div key={i} className="w-2 bg-black/60 rounded-full animate-pulse" style={{
                height: `${Math.max(20, Math.random() * 100)}%`,
                animationDelay: `${i * 0.1}s`
              }} data-id="element-142"></div>)}
              </div>
            </div>
            <div className="text-right" data-id="element-143">
              <p className="font-bold text-lg" data-id="element-144">Your Greeting</p>
              <p className="text-sm text-gray-700" data-id="element-145">Recorded by you</p>
            </div>
          </div>
        </div>

        <p className="text-xl text-gray-800 max-w-2xl mx-auto" data-id="element-146">
          "Hi! You've reached Sam and Alex. We're probably on the dance floor
          right now, but leave us a message after the beep!"
        </p>
      </div>
    </section>;
}